// extracted by mini-css-extract-plugin
module.exports = {"filterBody":"ReportFilter_filterBody__aejgs","content":"ReportFilter_content__Zgd73"};